var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8555 30.7895C24.3577 30.7895 31.2502 23.8971 31.2502 15.3948C31.2502 6.89247 24.3577 0 15.8555 0C7.35316 0 0.460693 6.89247 0.460693 15.3948C0.460693 23.8971 7.35316 30.7895 15.8555 30.7895Z",
    fill: "#43B4E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7264 9.27105C25.0003 9.59327 24.2203 9.8111 23.4003 9.90901C24.2372 9.40786 24.8784 8.61371 25.1811 7.66854C24.3861 8.14072 23.516 8.47313 22.6087 8.65134C21.8703 7.8643 20.8174 7.37292 19.6526 7.37292C17.4166 7.37292 15.6033 9.18553 15.6033 11.4228C15.6033 11.7398 15.639 12.049 15.7076 12.3459C12.3417 12.1768 9.35767 10.5645 7.36027 8.11459C7.01149 8.71292 6.81186 9.40859 6.81186 10.1508C6.81186 11.5557 7.52692 12.7952 8.61344 13.5213C7.97024 13.5014 7.34115 13.3278 6.77877 13.015V13.0662C6.77877 15.0285 8.17454 16.6648 10.0274 17.037C9.68699 17.1302 9.3298 17.1789 8.96028 17.1789C8.69901 17.1789 8.44553 17.1542 8.19791 17.1076C8.71328 18.7161 10.209 19.8869 11.9806 19.9199C10.5946 21.0065 8.8481 21.6541 6.95122 21.6541C6.62451 21.6541 6.30161 21.6346 5.98462 21.5964C7.77715 22.7458 9.9055 23.4168 12.1927 23.4168C19.6415 23.4168 23.7154 17.2457 23.7154 11.8941C23.7154 11.7184 23.7115 11.544 23.703 11.3703C24.4967 10.7962 25.1819 10.0853 25.7264 9.27105Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitter-logo.78ae408b81dba3f846ce7b26d868a083.svg";
export { ForwardRef as ReactComponent };